<template>

  <div class="cf">
    <div class="cf-success">

      <span class="cf-success__icon">✓</span>

      <div class="cf-stack" style="gap:10px;align-items:center">
        <span class="cf-eyebrow cf-eyebrow--muted">Rezygnacja</span>
        <h1 class="cf-h1">Dziękujemy</h1>
        <p class="cf-lead" style="margin:0 auto">Twoja rezygnacja została przyjęta. Zapraszamy do skorzystania
          z naszych usług w przyszłości.</p>
      </div>

    </div>
  </div>

</template>

<script>

    import { bus } from './main';

        

    export default {
     
       name: 'ZetosResignView',
 

       data(){

            return {

            }
       },


       methods: {



        gotomain(){

            this.$router.push({path: '/'});
        }
       }



        
    }
</script>

<style scoped>

.cf-page {
  padding: 44px 64px 56px;
  max-width: 960px;
}

.cf-easycheck__widget {
  padding: 24px;
  display: flex;
  justify-content: center;
}

@media (max-width: 900px) {

  .cf-page {
    padding: 24px 18px 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/ZetosResignView.vue